function clamp({
  amount,
  min,
  max
}) {
  return Math.min(Math.max(amount, min), max);
}

export { clamp };
